import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Avatar, CircularProgress, Grid, Paper, MenuItem, Card, Typography, TextField, Chip, Tab, Tabs } from "@mui/material";
import MyTable from "../../components/Schedule/MyTable";
import Modal from 'react-bootstrap/Modal';
import { useSnackbar } from "notistack";
import ApiService from "../../functions/apiService";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { formateDate } from "../../utils/helperFunctions";
import StatusInTable from "../../components/StatusInTable/StatusInTable";
// import EmptyState from "../../components/Error/EmptyState";
import { getGridStringOperators } from "@mui/x-data-grid";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { Col, Row } from 'react-bootstrap';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AuthContext from "../../context/AuthContext";
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import ManageFreePasses from "./ManageFreePasses";
import { toast } from "react-toastify";
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { varFormatTime } from "../../utils/helperFunctions";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import DescriptionIcon from '@mui/icons-material/Description';

const buttonStyle = {
  backgroundColor: "#fff",
  border: "1px solid #D0D5DD",
  color: "#333",
  width: "108px",
  marginRight: "8px",
};

const ApproveShifts = () => {
  const { user, pages, permission, v3Data, approveRtoCount , refreshApproveRtoCount } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsLength, setRowsLength] = useState(0);
  // const [dates, setDates] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState(false);
  // const { enqueueSnackbar } = useSnackbar();
  const [activeTab, setActiveTab] = useState('approve')
  const [otRows, setOtRows] = useState([]);
  const [otSwapsLength, setOtSwapslength] = useState(0);
  const [vacRows, setVacRows] = useState([]);
  const [vacSwapsLength, setVacSwapslength] = useState(0);
  const [freePasses, setFreePasses] = useState([])
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
  const [removeRtoList, setRemoveRtoList] = useState([]);
  const [removeRtoLength, setRemoveRtoLength] = useState(0);
  const [sortDrop, setSortDrop] = useState("");
  const [order, setOrder] = useState("Shift_Date");
  const [sortType, setSortType] = useState("asc");
  const [denyModal, setDenyModal] = useState(false);
  const [reasonModal, setReasonModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');
  const [reason, setReason] = useState('');
  const [allowedVars, setAllowedVars] = useState({})
  const [sellHolidayRequest, setSellHolidayRequest] = useState([]);
  const [notesModal, setNotesModal] = useState(false);
  const [notesData, setNotesData] = useState('');
  const [commentModal, setCommentModal] = useState('')
  const [commentData, setCommentData] = useState('')
  const [swapCancelRequestData, setSwapCancelRequestData] = useState([]);
  const [dailySwapListData, setDailySwapListData] = useState([]);
  const [selectedSwapData, setSelectedSwapData] = useState([]);
  const [show, setShow] = useState(false);
  const [swapReason, setSwapReason] = useState('');
  const [odtRows, setOdtRows] = useState([]);
  const [odtLength, setOdtLength] = useState(0);
  const [approveModal, setApproveModal] = useState(false);
  const [approveReason, setApproveReason] = useState('');
  const [statusFilter, setStatusFilter] = useState('pending');
  const [selectedEmployees, setSelectedEmployess] = useState([]);
  const [selectSingleRow, setSelectSignleRow] = useState();
  const [number, setNumber] = useState(2);
  const [selectSingleRowData, setSelectSignleRowData] = useState([])
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const [nonSwapDeleteModal, setNonSwapDeleteModal] = useState(false);
  const [selectedDeleteRow, setSelectedDeleteRow] = useState(null);

  const onRowSelectionModelChange = (newRowSelectionModel) => {
    setRowSelectionModel(newRowSelectionModel);
  };

  const groupByShiftDate = (data) => {
    return data.reduce((acc, item) => {
      const date = item.Shift_Date;

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(item);
      return acc;
    }, {});
  };

  const formatGroupedData = (groupedData) => {
    return Object.keys(groupedData).map((date) => ({
      shiftDate: date,
      rows: groupedData[date],
      id: date
    }));
  };
  
  const loadData = () => {
    setLoading(true);

    ApiService.get(`/getApproveShifts?order=${order}&sort=${sortType}`, {}, 'getApproveShifts')
      .then(({ data }) => {

        const grouped = groupByShiftDate(data);
        const formattedData = formatGroupedData(grouped);

        setRows(formattedData);
        setRowsLength(data.length);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Error");
      });
  };

  const loadOTSwaps = () => {
    setLoading(true);
    ApiService.post("/ot-swap-admin-list")
      .then(({ data }) => {
        setOtRows(data);
        setOtSwapslength(data.length)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadOTSwaps();
  }, [activeTab == 'otswaps'])

  const getInitialDates = () => {
    const today = moment();

    let augustFirst = moment({ year: today.year(), month: 7, day: 1 });

    if (today.isBefore(augustFirst)) {
      augustFirst = augustFirst.subtract(1, 'year');
    }
    const latestAugustFirstYear = augustFirst.year();
    setStartDate(`${latestAugustFirstYear}-08-01`)

    let julyFirst = moment({ year: today.year(), month: 6, day: 1 });

    if (!today.isBefore(julyFirst)) {
      julyFirst = julyFirst.add(1, 'year');
    }
    const upcomingJulyFirstYear = julyFirst.year();
    setEndDate(`${upcomingJulyFirstYear}-07-31`)
  }

  const getFreePasses = () => {
    setLoading(true);
    ApiService.get(`/rfp-admin-list?start_date=${startDate}&end_date=${endDate}`)
      .then(({ data }) => {
        var tempArr = data?.data?.map((rfp, i) => { return { id: i + 1, ...rfp } })
        setFreePasses(tempArr)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    getInitialDates()
    getAllowedVars()
    // loadData()
  }, []);

  useEffect(() => {
    loadData();
    refreshApproveRtoCount();
  }, [order, sortType]);

  useEffect(() => {
    if (pages.includes("ACCEPT_SHIFT_PASS")) {
      getFreePasses()
    }
  }, [startDate, endDate])

  const allRows = rows.flatMap(group => group.rows);

  const Approve = (arr = [], num = 2) => {
    setSaving(true);
    const shifts = [];
    if (number === 1) {
      shifts.push(selectSingleRow);
    } else {
      const selected = allRows.filter((r) =>
        rowSelectionModel.includes(r.id)
      );

      selected.forEach((r) =>
        shifts.push([r.Shift_Number, r.Shift_Date])
      );
    }

    const payload = {
      Shifts: shifts,
      Action: "Approve",
      Approve_Reason: approveReason,
    };

    ApiService.post("/postApproveShifts", payload)
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        setApproveModal(false);
        setApproveReason('');
        loadData();
        refreshApproveRtoCount();
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setSaving(false);
      });
  };

  const Deny = (arr = [], num = 2) => {
    setSaving(true);
    const shifts = [];
    if (number === 1) {
      shifts.push(selectSingleRow);
    } else {
      const selected = allRows.filter((r) =>
        rowSelectionModel.includes(r.id)
      );
      selected.forEach((r) =>
        shifts.push([r.Shift_Number, r.Shift_Date])
      );
    }
    const payload = {
      Shifts: shifts,
      Reject_Reason: rejectReason,
      Action: "Deny",
    };

    ApiService.post("/postApproveShifts", payload)
      .then((data) => {
        setRejectReason("")
        setSaving(false);
        toast.success(data?.message)
        // enqueueSnackbar("success", { variant: "success" });
        loadData();
        refreshApproveRtoCount();
        setDenyModal(false);
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setSaving(false);
      });
  };

  let getAllowedVars = () => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAllowedVars(res?.data?.data)
      }).catch(({ error }) => {
        console.log('error', error)
      });
  }
  const loadOffDutyTraining = () => {
    setLoading(true);
    ApiService.get("/offDutyTraining")
      .then(({ data }) => {

        setOdtRows(data?.data);
        setOdtLength(data?.data?.length || 0);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        // toast.error("Failed to load off-duty training requests");
      });
  };

  useEffect(() => {
    loadOffDutyTraining()
    if (activeTab === "off-duty") {
      loadOffDutyTraining();
    }
    loadOffDutyTraining();
  }, []);

  const filteredRows = rows
    .map((group) => ({
      ...group,
      rows:
        statusFilter === "all"
          ? group.rows
          : group.rows.filter((row) => {
            if (statusFilter === "pending") return row.Status === "Q";
            if (statusFilter === "rejected") return row.Status === "X";
            return true;
          }),
    }))
    .filter((group) => group.rows.length > 0);

  const counts = rows.reduce(
    (acc, group) => {
      group.rows.forEach((row) => {
        acc.all += 1;
        if (row.Status === "Q") acc.pending += 1;
        if (row.Status === "X") acc.rejected += 1;
      });
      return acc;
    },
    { all: 0, pending: 0, rejected: 0 }
  );


  const odtColumns = [
    {
      field: "RequestDateEmployee",
      headerName: "Date / Employee",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{moment(params?.row?.Request_Date).format('MM/DD/YYYY')}</span>
          <span>{params?.row?.employee?.fullName}</span>
        </div>
      )
    },
    {
      field: "Class_Name",
      headerName: "Class Name",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => <div style={{
        padding: "14px 0",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        lineHeight: "1.4"
      }}
      >{params?.row?.Class_Name}</div>

    },
    {
      field: "TrainingTime",
      headerName: "Start / End Time",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span>{params?.row?.Training_Start_Time}</span>
          <span>{params?.row?.Training_End_Time}</span>
        </div>
      )
    },
    {
      field: "PaidInfo",
      headerName: "Payment Info",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        const isPaid = params?.row?.Is_Paid;
        const paymentType = params?.row?.Payment_Type;
        const formattedType = paymentType
          ? paymentType.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
          : "NA";

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{isPaid ? "Paid" : "Unpaid"}</span>
            <span>{isPaid ? formattedType : "NA"}</span>
          </div>
        );
      }
    },

    {
      field: "Training_Location",
      headerName: "Location",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => <div style={{
        padding: "14px 0",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        lineHeight: "1.4"
      }}>{params?.row?.Training_Location}</div>

    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      minWidth: 40,
      renderCell: (params) => (
        <Chip
          label={params.value}
          sx={{
            backgroundColor: params.value === 'Pending'
              ? 'rgba(255, 165, 0, 0.16)'
              : params.value === 'Approved'
                ? 'rgba(1, 120, 79, 0.1)'
                : 'rgba(230, 39, 25, 0.1)',
            color: params.value === 'Pending'
              ? '#FF8C00'
              : params.value === 'Approved'
                ? 'rgba(1, 120, 79, 1)'
                : '#ff0000',
            border: params.value === 'Pending'
              ? '1px solid rgba(255, 165, 0, 0.28)'
              : params.value === 'Approved'
                ? '1px solid rgba(1, 120, 79, 1)'
                : '1px solid rgba(230, 39, 25, 0.4)'
          }}
        />
      )
    },
    {
      field: "Action_By",
      headerName: "Action By",
      flex: 1,
      minWidth: 40,
      renderCell: (params) => <div style={{ padding: '14px 0px' }}>{params?.row?.action_by_employee?.fullName}</div>
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 40,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        // Only show actions if status is Pending
        if (params.row.Status !== 'Pending') {
          return null;
        }

        return (
          <div style={{ display: "flex", gap: 12 }}>
            <Button
              onClick={() => handleOdtAction(params.row, 'approve')}
              sx={{
                color: "#555555",
                minWidth: "0",
                paddingRight: ".02rem",
                ":hover": { color: "green", background: "none" },
              }}
              startIcon={<CheckIcon />}
              disabled={saving}
            />
            <Button
              onClick={() => handleOdtAction(params.row, 'reject')}
              sx={{
                color: "#555555",
                minWidth: "0",
                paddingRight: ".02rem",
                ":hover": { color: "red", background: "none" },
              }}
              startIcon={<ClearIcon />}
              disabled={saving}
            />
          </div>
        );
      },
    }

  ];
  // const handleOdtAction = (row, action) => {
  //   console.log("row==>413",row.Id,action)
  //   const status = action === 'approve' ? 'Approved' : 'Rejected';
  //   setSaving(true);
  //   ApiService.post(`/offDutyTraining/changeStatus/?${row.Id}`, {
  //     'status': status
  //   })
  //     .then((data) => {
  //       setSaving(false);
  //       toast.success(data?.message || `Request ${action}d successfully`);
  //       loadOffDutyTraining();
  //     })
  //     .catch((error) => {
  //       setSaving(false);
  //       toast.error(error?.data?.message || `Failed to ${action} request`);
  //     });
  // };
  const handleOdtAction = (row, action) => {
    console.log("row==>413", row.Id, action);
    const status = action === 'approve' ? 'Approved' : 'Rejected';
    setSaving(true);

    // Fixed URL - removed the '?' before row.Id
    ApiService.post(`/offDutyTraining/changeStatus/${row.Id}`, {
      'Status': status  // Capital 'S' to match your Postman format
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message || `Request ${action}d successfully`);
        loadOffDutyTraining();
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error?.data?.message || `Failed to ${action} request`);
      });
  };
  const openAcceptedinSameDateModel = (acceptedinSameDateModel) => {
    setOpen(true);
    setModalData(acceptedinSameDateModel);
  };

  const checkButtonStyle = {
    color: "#555555",
    minWidth: "0",
    paddingRight: ".02rem",
    ":hover": { color: "green", background: "none" },
  };

  const checkButtonStyle2 = {
    color: "#555555",
    minWidth: "0",
    paddingRight: ".02rem",
    ":hover": { color: "#555555", background: "none" },
  };

  const clearButtonStyle = {
    color: "#555555",
    minWidth: "0",
    paddingRight: ".02rem",
    ":hover": { color: "red", background: "none" },
  };

  const columns = [
    {
      field: "Shift_Date",
      headerName: "Date",
      flex: 1,
      minWidth: 180,
      maxWidth: 180,
      valueGetter: (params) => formateDate(params.row.Shift_Date, "YYYY-MM-DD HH:ii:ss"),
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
    },
    {
      field: "Last_name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
      maxWidth: 170,
      renderCell: (params) =>
        params?.row?.Absent_Code == "SWAP" ? (
          <>
            {params.row.Orig_Emp_EA_Rank} {params.row.Orig_Emp_fullName} With
            <br />
            ({params?.row?.Overtime_Swap_Log?.Emp_EA_Rank} {params?.row?.Overtime_Swap_Log?.Emp_fullName})
          </>
        ) : (
          <>
            {params.row.Orig_Emp_EA_Rank} {params.row.Orig_Emp_fullName}
          </>),
      // params?.row?.Absent_Code == "SWAP" ? (params.row.Orig_Emp_EA_Rank + " " + params.row.Orig_Emp_fullName + "\nSwap with (" + params?.row?.Overtime_Swap_Log?.Emp_EA_Rank + " " + params?.row?.Overtime_Swap_Log?.Emp_fullName + ")") : params.row.Orig_Emp_EA_Rank + " " + params.row.Orig_Emp_fullName,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Orig_Emp_EHd_Seniority",
      headerName: "Seniority",
      flex: 1,
      minWidth: 80,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Overtime_List",
      headerName: "Shift",
      flex: 1,
      minWidth: 170,
      maxWidth: 200,
      valueGetter: (params) =>
        params.row.Shift_Code > 90 ? `${varFormatTime(`${params.row.Start_Time}-${params.row.End_Time}`, user?.Time_Format)}` : params.row.Shift_Type
    },
    {
      field: "Reason",
      headerName: "Absent Reason",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: '1.5' }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 180,
      maxWidth: 180,
      renderCell: (params) => {
        if (params.row.StatusText) {
          const rejectReasondata = params?.row?.Reject_Reason?.Value;
          return (
            <>
              <StatusInTable StatusText={params.row.StatusText} StatusColor={params.row.StatusColor} />
              {rejectReasondata &&
                <Button
                  onClick={() => {
                    setReason(rejectReasondata);
                    setTimeout(() => setReasonModal(true), 500);
                  }}
                  sx={checkButtonStyle2}
                  startIcon={
                    <DescriptionIcon style={{ width: 28, height: 24, marginLeft: '6px' }} />
                  }
                />
              }
            </>
          );
        }
        return <span></span>;
      },
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
    },
    {
      field: "timeStamp",
      headerName: "Timestamp",
      flex: 1,
      minWidth: 200,
      maxWidth: 200,
      valueGetter: (params) => formateDate(params.row.Create_Time, "YYYY-MM-DD HH:ii:ss"),
      filterOperators: getGridStringOperators().filter((operator) => operator.value === "contains"),
    },
    // {
    //   field: "acceptedinSameDate",
    //   headerName: "Assignees",
    //   flex: 1,
    //   minWidth: 120,
    //   filterOperators: getGridStringOperators().filter(
    //     (operator) => operator.value === "contains"
    //   ),
    //   renderCell: (params) => {
    //     const arr = [params.row.Shift_Number, params.row.Shift_Date];
    //     return (
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "space-evenly",
    //           width: "100%",
    //         }}
    //       >
    //         <Button
    //           onClick={() =>
    //             openAcceptedinSameDateModel(
    //               params.row.acceptedinSameDate
    //             )
    //           }
    //           sx={clearButtonStyle}
    //         >
    //           {params.row.acceptedinSameDate.length}
    //         </Button>
    //       </div>
    //     );
    //   },
    // },
    {
      field: "buttons",
      headerName: "Approve/Deny",
      flex: 1,
      minWidth: 120,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const arr = [params.row.Shift_Number, params.row.Shift_Date];
        return (
          <div
            style={{
              display: "flex",
              // justifyContent: "space-evenly",
              width: "100%",
              gap: 12
            }}
          >
            <Button
              // onClick={() => Approve(arr, 1)}
              onClick={() => {
                {
                  setApproveModal(true)
                }
                setSelectSignleRow(arr)
                setSelectSignleRowData(params?.row)
                setNumber(1)
              }}
              sx={checkButtonStyle}
              startIcon={<CheckIcon />}
            ></Button>
            <Button
              // onClick={() => Deny(arr, 1)}
              onClick={() => {
                setDenyModal(true)
                setSelectSignleRow(arr)
                setSelectSignleRowData(params?.row)
                setNumber(1)
              }}
              sx={clearButtonStyle}
              startIcon={<ClearIcon />}
            ></Button>

          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      maxWidth: 150,
      renderCell: (params) => {
        const rejectReasondata = params?.row?.Status;
        return (
          <>
            <div style={{ display: "flex", gap: "12px" }}>
              <div
                onClick={() => {
                  setCommentModal(true)
                  setCommentData(params?.row?.User_Rto_Reason)
                }}
                style={{ cursor: "pointer" }}
              >
                <img src="/images/comment.svg" height="20px" width="20px" />
              </div>
              {params?.row?.Reason === "Swap" ? (<div
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteData(params?.row);
                }}
                style={{ cursor: "pointer" }}
              >
                <img src="/images/delete.svg" height="20px" width="20px" />
              </div>) : ((v3Data?.V3_DELETE_DENIED_PTO_REQUEST && rejectReasondata === 'X') && < div
                onClick={() => {
                  setNonSwapDeleteModal(true);
                  setSelectedDeleteRow(params?.row)
                }}
                style={{ cursor: "pointer" }}
              >
                <img src="/images/delete.svg" height="20px" width="20px" />
              </div>)}
            </div> 
          </>
        );
      },
    }
  ];

  const columns2 = [
    {
      field: "Shift_Date",
      headerName: "Date",
      flex: 1,
      valueGetter: (params) =>
        moment(params.row.Shift_Date).format('MM/DD/YYYY')
    },
    {
      field: "Shift_Number",
      headerName: "Shift Number",
      flex: 1,
    },
    {
      field: "Absent_Code",
      headerName: "Absent Code",
      flex: 1,
    },
    {
      field: 'Shift_Code',
      headerName: 'Shift',
      width: 220,
      renderCell: (params) => {
        const status = params.value;
        return <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '60%',
            color: '#2E3238',
            backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
            border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
          }}
          label={status === 2 ? 'Day' : status === 91 ? `Custom` : 'Night'}
        />;
      },
    },
    {
      field: "Request_By",
      headerName: "Request By",
      flex: 1,
    },
    {
      field: "Request_To",
      headerName: "Request To",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      maxWidth: 150,
      renderCell: (params) => {
        return (
          <>
            <Button
              variant="contained"
              onClick={() => {
                setShow(true)
                setSelectedSwapData(params?.row)
              }}
              sx={{
                backgroundColor: '#ff0000',
                color: '#ffffff',
                marginLeft: '10px',
                padding: '8px',
                boxShadow: 'none',
              }}
            >	{'Cancel Swap'}
            </Button>
          </>
        );
      },
    }
  ];

  const acceptOTswaps = (row, decision) => {
    setSaving(true);
    ApiService.post("/ot-swap-admin-decision", {
      "Shift_Date": row.Shift_Date,
      "Shift_Number": row.Shift_Number,
      "Emp_Code": row.swap_with.Emp_Code,
      "decision": decision,
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.data)
        loadOTSwaps();
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  };

  const loadVacationSwaps = () => {
    setLoading(true);
    ApiService.post("/ot-open-vac-requests")
      .then(({ data }) => {
        setVacRows(data)
        setVacSwapslength(data?.length)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadVacationSwaps();
  }, [activeTab == 'vswaps']);

  const acceptVacswaps = (row, decision) => {
    setSaving(true);
    ApiService.post("/ot-open-vac-decision", {
      "Shift_Date": row.Shift_Date,
      "Shift_Number": row.Shift_Number,
      "Emp_Code": row.Emp_Code,
      "Action": row.Action,
      "Value": row.Value,
      "Create_Emp_Code": row.Create_Emp_Code,
      "decision": decision,
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        // enqueueSnackbar("success", { variant: "success" });
        loadVacationSwaps();
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error?.data?.message)
        // enqueueSnackbar(error.data.message, { variant: "error" });
      });
  };

  const loadCancelLeaveList = () => {
    setLoading(true);
    ApiService.get("/rto-removal-list")
      .then(({ data }) => {
        setRemoveRtoList(data?.data)
        setRemoveRtoLength(data?.data?.length)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadCancelLeaveList();
  }, [activeTab == 'removeRtoList']);

  const removeRtoRequestDecesion = (row, decision) => {
    setSaving(true);
    ApiService.post("/rto-removal-admin-decision", {
      "Shift_Date": row.Shift_Date,
      "Shift_Number": row.Shift_Number,
      "Emp_Code": row.Emp_Code,
      "decision": decision,
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadCancelLeaveList();
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error?.data?.message)
      });
  };

  const sortOptions = [
    { label: "Shift Date (↑)", value: "1", order: "Shift_Date", sort: "asc" },
    { label: "Shift Date (↓)", value: "2", order: "Shift_Date", sort: "desc" },
    { label: "Timestamp (↑)", value: "3", order: "Create_Time", sort: "asc" },
    { label: "Timestamp (↓)", value: "4", order: "Create_Time", sort: "desc" },
  ]
  const sellHolidayList = () => {
    setLoading(true);
    ApiService.get("/adminAllAccrualRequests")
      .then(({ data }) => {
        setSellHolidayRequest(data?.data)
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    sellHolidayList();
  }, [activeTab == 'sholiday']);

  const acceptSellHolidayRequest = (row) => {
    setSaving(true);
    ApiService.get(`/acceptAccrualRequest/${row?.Accrual_Request_Id}`)
      .then((data) => {
        setSaving(false);
        toast.success(data?.data?.message, { variant: "success" });
        sellHolidayList()
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error.response.data.message, { variant: "error" });
      });
  };

  const rejectSellHolidayRequest = (row) => {
    setSaving(true);
    ApiService.get(`/rejectAccrualRequest/${row?.Accrual_Request_Id}`)
      .then((data) => {
        setSaving(false);
        toast.success(data?.data?.message, { variant: "success" });
        sellHolidayList()
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error.response.data.message, { variant: "error" });
      });
  };

  const swapCancelRequest = (row) => {
    setSaving(true);
    ApiService.get(`/swap-cancel-admin-list`)
      .then((data) => {
        setSaving(false);
        setSwapCancelRequestData(data?.data?.date)
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error.response.data.message, { variant: "error" });
      });
  };

  useEffect(() => {
    swapCancelRequest()
  }, [activeTab == 'swap-cancel'])

  const handleCancelSwapRequest = (row, decision) => {
    setSaving(true);
    ApiService.post("/swap-cancel-admin-decision", {
      "Emp_Code": row?.Emp_Code,
      "Shift_Date": row?.Shift_Date,
      "Shift_Number": row?.Shift_Number,
      "Shift_Code": row?.removal_request_shifts[0].Shift_Code,
      "decision": decision
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        swapCancelRequest();
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error?.data?.message)
      });
  };

  const dailySwapList = (row) => {
    setSaving(true);
    ApiService.get(`/adminSwapListDaily`)
      .then((data) => {
        setSaving(false);
        const responseData = data?.data?.data || {};
        const arrayData = Object.entries(responseData).map(([key, value]) => ({
          id: key,
          ...value,
        }));
        setDailySwapListData(arrayData);
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error.response.data.message, { variant: "error" });
      });
  };

  useEffect(() => {
    dailySwapList();
  }, [activeTab == 'daily-swap-list'])

  const handleDailySwapCancel = (row) => {
    setSaving(true);
    ApiService.post("/adminSwapDailyCancel", {
      "Shift_Number": row?.Shift_Number,
      "Shift_Date": row?.Shift_Date,
      "Shift_Code": row?.Shift_Code,
      "Emp_Code": row?.Orig_Emp_Code,
      "Swap_Emp_Code": row?.Emp_Code,
      "Comment": swapReason
    })
      .then((data) => {
        setSaving(false);
        setSwapReason('');
        setShow(false);
        toast.success(data?.log_msg)
        dailySwapList();
      })
      .catch((error) => {
        setSaving(false);
        toast.error(error?.data?.message)
      });
  };

  const handleSelectedEmployees = (arr = [], num = 2) => {
    const shifts = [];
    if (num === 1) {
      shifts.push(arr);
    } else {
      const selected = allRows.filter((r) =>
        rowSelectionModel.includes(r.id)
      );

      selected.forEach((r) =>
        shifts.push([r.Shift_Type, r.Shift_Date, r.Orig_Emp_fullName])
      );
    }
    setSelectedEmployess(shifts)
  };

  useEffect(() => {
    handleSelectedEmployees()
  }, [rowSelectionModel])

  const groupedEmployees = selectedEmployees.reduce((acc, [shift, date, name]) => {
    if (!acc[name]) acc[name] = [];
    acc[name].push(`${moment(date).format('MM/DD/YYYY')} (${shift})`);
    return acc;
  }, {});

  const handleDelete = async () => {
    if (!deleteData) return;

    setLoading(true);
    const payload = {
      EmpCode: deleteData?.Orig_Emp_Code,
      SwapEmp: deleteData?.Overtime_Swap_Log?.Emp_Code,
      ShiftDate: deleteData?.Shift_Date,
      ShiftCode: deleteData?.Shift_Code,
      ShiftNumber: deleteData?.Shift_Number,
      AbsentCode: deleteData?.AbsentCode || "SWAP",
    };
    ApiService.post("/deleteSwapPTORequest", payload)
      .then((data) => {
        setDeleteModal(false);
        toast.success(data?.message)
        loadData();
        refreshApproveRtoCount();
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setLoading(false);
      });
  };
  const handleDeniedRTORequst = async () => {
    if (!selectedDeleteRow) return;

    setLoading(true);
    const payload = {
      EmpCode: selectedDeleteRow?.Orig_Emp_Code,
      ShiftDate: selectedDeleteRow?.Shift_Date,
      ShiftCode: selectedDeleteRow?.Shift_Code,
      ShiftNumber: selectedDeleteRow?.Shift_Number,
    };
    ApiService.post("/deletePTORequest", payload)
      .then((data) => {
        setNonSwapDeleteModal(false)
        toast.success(data?.message)
        loadData();
        refreshApproveRtoCount();
      })
      .catch((error) => {
        toast.error(error?.data?.message);
        setLoading(false);
      });
  };
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setNonSwapDeleteModal(false);
  };



  return (
    <>
      {/* <ManagementHeaderNav /> */}
      <Paper className="p-3" style={{ marginTop: '1rem', maxWidth: '93vw', overflowX: 'auto', }}>
        <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
          <Grid item xs={12}>
            <div style={{ display: 'flex', justifyContent: 'space-between', height: '40px' }}>
              <div>
                <Typography variant="h5">Approve RTO</Typography>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                {activeTab == 'approve' &&
                  <div className="mt-1">
                    <ButtonTheme onClick={() => setApproveModal(true)} color='primary'
                      disabled={
                        rowSelectionModel.length === 0 || saving
                      }>
                      Approve
                    </ButtonTheme>

                    <ButtonTheme onClick={() => setDenyModal(true)}
                      color='primary' className='mx-2'
                      disabled={
                        rowSelectionModel.length === 0 || saving
                      }
                    >
                      Deny
                    </ButtonTheme>
                  </div>
                }
                <div style={{ width: '210px', marginLeft: 'auto' }}>
                  <TextField
                    select
                    variant="outlined"
                    color="secondary"
                    size="small"
                    value={sortDrop}
                    onChange={(e) => {
                      const selected = sortOptions.find(opt => opt.value === e.target.value);
                      setSortDrop(e.target.value);
                      setSortType(selected?.sort);
                      setOrder(selected?.order);
                    }}
                    label="Sort By"
                    InputProps={{
                      sx: {
                        height: '48px',
                        fontSize: '14px'
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        marginTop: '4px',
                        fontSize: "14px"
                      },
                    }}
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "48px",
                        fontSize: "1rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      },
                      "& .MuiFormLabel-root": {
                        marginTop: "4px"
                      },
                      "& .MuiInputLabel-shrink": {
                        marginTop: "0px"
                      }
                    }}
                  >
                    {sortOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>
            </div>
            <div style={{ marginTop: '25px' }}>
              <Row>
                <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                  <div
                    style={{ width: '230px' }}
                    className={activeTab === 'approve' ? 'tab-active mx-1' : 'tab-white mx-1'}
                    onClick={() => setActiveTab('approve')}
                  >
                    {
                      v3Data?.V3_APPROVE_RTO_COUNTER_BADGE === 'true' ? (
                        <>RTO Request ({approveRtoCount || counts?.pending })</>
                      ) : (
                        <>Approve/Deny Shifts ({rowsLength})</>
                      )
                    }
                  </div>
                </Col>

                <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                  <div
                    style={{ width: '210px' }}
                    className={activeTab === 'sholiday' ? 'tab-active mx-1' : 'tab-white mx-1'}
                    onClick={() => setActiveTab('sholiday')}
                  >
                    Sell Holiday Request ({sellHolidayRequest?.length})
                  </div>
                </Col>

                {(pages.includes('V3_OT_SWAPS_FEATURE')) &&
                  <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                    <div style={{ width: '200px' }} className={activeTab == 'otswaps' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => setActiveTab('otswaps')}>
                      OT Swap Requests ({otSwapsLength})
                    </div>
                  </Col>
                }

                {allowedVars?.V3_OFF_DUTY_TRAINING_MODULE && (permission.includes('Emp_Auth') || permission.includes('master_user')) &&
                  <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                    <div
                      style={{ width: '230px' }}
                      className={activeTab === 'off-duty' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => setActiveTab('off-duty')}
                    >
                      Off Duty Training Request ({odtLength})
                    </div>
                  </Col>
                }

                {(pages.includes('V3_VAC_SWAPS_FEATURE')) &&
                  <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                    <div style={{ width: '210px' }} className={activeTab == 'vswaps' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => setActiveTab('vswaps')}>
                      Vacation Swap Requests ({vacSwapsLength})
                    </div>
                  </Col>
                }

                {(pages.includes("V3_DELETE_VACATION_REQUESTS")) &&
                  <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                    <div style={{ width: '190px' }} className={activeTab == 'removeRtoList' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => setActiveTab('removeRtoList')}>
                      Remove RTO List ({removeRtoLength})
                    </div>
                  </Col>
                }

                {pages.includes("ACCEPT_SHIFT_PASS") &&
                  <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                    <div style={{ width: '210px' }} className={activeTab == 'passes' ? 'tab-active mx-1' : 'tab-white mx-1'}
                      onClick={() => setActiveTab('passes')}>
                      Manage Free Passes {`(${freePasses.length})`}
                    </div>
                  </Col>
                }

                <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                  <div style={{ width: '200px' }} className={activeTab == 'swap-cancel' ? 'tab-active mx-1' : 'tab-white mx-1'}
                    onClick={() => setActiveTab('swap-cancel')}>
                    Swap Cancel Request {`(${swapCancelRequestData.length})`}
                  </div>
                </Col>

                {/* <Col style={{paddingRight:'0px' , paddingLeft:'0px' , flex:'0.1' , marginBottom:'10px'}}>
									<div style={{ width: '170px' }} className={activeTab == 'daily-swap-list' ? 'tab-active mx-1' : 'tab-white mx-1'}
										onClick={() => setActiveTab('daily-swap-list')}>
										Daily Swap List {`(${dailySwapListData.length})`}
									</div>
								</Col> */}

              </Row>

              {activeTab == 'passes' &&
                <Row>
                  <Col style={{ paddingRight: '0px', paddingLeft: '0px', flex: '0.1', marginBottom: '10px' }}>
                    <div className="d-flex justify-content-end" style={{ gap: 16, paddingLeft: '16px' }}>
                      <div>
                        <label className='mb-1'>Start Date</label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <ButtonDatePicker
                            className='w-100'
                            label={moment(startDate).format('MM/DD/YYYY')}
                            value={new Date(startDate)}
                            maxDate={new Date()}
                            onChange={(e) => setStartDate(moment(e).format('YYYY-MM-DD'))}
                          />
                        </LocalizationProvider>
                      </div>

                      <div>
                        <label className='mb-1'>End Date</label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <ButtonDatePicker
                            className='w-100'
                            label={moment(endDate).format('MM/DD/YYYY')}
                            value={new Date(endDate)}
                            minDate={new Date(startDate)}
                            onChange={(e) => setEndDate(moment(e).format('YYYY-MM-DD'))}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </Col>
                </Row>
              }

              {loading && (
                <Box className="w-100 d-flex justify-content-center align-items-center mt-2"
                  style={{ height: '510px' }}>
                  <CircularProgress />
                </Box>
              )}

              {!loading && activeTab === 'approve' && (
                <>
                  {(v3Data?.V3_APPROVE_RTO_COUNTER_BADGE === 'True' || v3Data?.V3_APPROVE_RTO_COUNTER_BADGE === 'true') ? (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "8px",
                          background: "#F4F6F8",
                          padding: "6px",
                          borderRadius: "8px",
                          width: "fit-content",
                          mb: 2,
                        }}
                      >
                        {[
                          { label: "All", value: "all", count: counts.all },
                          { label: "Pending", value: "pending", count: counts.pending },
                          { label: "Rejected", value: "rejected", count: counts.rejected },
                        ].map((item) => (
                          <Box
                            key={item.value}
                            onClick={() => setStatusFilter(item.value)}
                            sx={{
                              px: 2.5,
                              py: 0.8,
                              borderRadius: "6px",
                              fontSize: "14px",
                              fontWeight: 500,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                              color: statusFilter === item.value ? "#000" : "#6B7280",
                              backgroundColor:
                                statusFilter === item.value ? "#FFFFFF" : "transparent",
                              boxShadow:
                                statusFilter === item.value
                                  ? "0px 1px 3px rgba(0,0,0,0.12)"
                                  : "none",
                              transition: "all 0.2s ease",
                            }}
                          >
                            {item.label}
                            <Box
                              sx={{
                                fontSize: "12px",
                                fontWeight: 600,
                                background: "#E5E7EB",
                                px: 1,
                                borderRadius: "10px",
                                color: "#374151",
                              }}
                            >
                              {item.count}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                          marginTop: "1rem",
                        }}
                      >
                        {filteredRows.length > 0 &&
                          filteredRows.map((data) => (
                            <div key={data.shiftDate} className="hide-header-checkbox-page">
                              <CollapseComponent
                                rows={data.rows}
                                name={moment(data.shiftDate).format('ddd Do MMM YYYY')}
                                columns={columns}
                                useTopFilter={false}
                                hideFooter
                                rowSelectionModel={rowSelectionModel}
                                open
                                onRowSelectionModelChange={onRowSelectionModelChange}
                              />
                            </div>
                          ))}

                        {filteredRows.length === 0 && (
                          <div
                            className="d-flex flex-column align-items-center justify-content-center"
                            style={{ height: 500 }}
                          >
                            <img src="/images/blur-logo.png" style={{ height: 200, width: 250 }} />
                            <span className="mt-4" style={{ color: "#555555" }}>
                              No Shifts Found
                            </span>
                          </div>
                        )}
                      </Box>
                    </>) : (
                    <Box
                      sx={{
                        maxWidth: "93vw",
                        overflowX: "auto",
                        background: "#FFF",
                        marginTop: "1rem",
                      }}
                    >
                      {rows.length > 0 && rows.map((data) => (
                        <div className="hide-header-checkbox-page">
                          <CollapseComponent
                            rows={data.rows}
                            name={`${moment(data.shiftDate).format('ddd Do MMM YYYY')}`}
                            columns={columns}
                            useTopFilter={false}
                            hideFooter={true}
                            rowSelectionModel={rowSelectionModel}
                            open={true}
                            onRowSelectionModelChange={onRowSelectionModelChange} />
                        </div>
                      ))}

                      {rows.length == 0 &&
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                          <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                          <span className='mt-4' style={{ color: '#555555' }}>
                            No Shifts Found
                          </span>
                        </div>
                      }
                    </Box>)}
                </>
              )}
              {!loading && activeTab === "off-duty" && (
                <Box
                  sx={{
                    maxWidth: "93vw",
                    overflowX: "auto",
                    background: "#FFF",
                    marginTop: "1rem",
                  }}
                >


                  {odtRows.length > 0 ? (
                    <div className="hide-header-checkbox-page">
                      <MyTable
                        rows={odtRows}
                        columns={odtColumns}
                        // useTopFilter={false}
                        hideFooter={false}
                        checkboxSelection={false}
                        useCustomId={true}
                        minHeightRow="auto"
                      />
                    </div>
                  ) : (
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                      <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                      <span className='mt-4' style={{ color: '#555555' }}>
                        No Off-Duty Training Requests Found
                      </span>
                    </div>
                  )}
                </Box>
              )}
              {activeTab == 'otswaps' &&
                <>
                  <div>
                    {!loading && (
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                        }}
                      >
                        <Grid container spacing={2} className='mt-2 mb-3'>
                          {otRows.length > 0 ? (
                            otRows.map((obj) => {
                              {
                                return (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        padding: '16px',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        border: '1px solid #EBECF0',
                                        boxShadow: `
                                        0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                        0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                        0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                      `,
                                      }}
                                    >
                                      <TableContainer>
                                        <Table aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                Shift
                                              </TableCell>
                                              <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                                {obj?.swap_by_shift_details?.Shift_Code == '2' ? 'Day' : 'Night'}
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            <TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                style={{
                                                  padding: '0px',
                                                  fontSize: '14px',
                                                  fontFamily: 'karla',
                                                  padding: '7px',
                                                  color: '#555555'
                                                }}
                                              >
                                                <p style={{ marginBottom: '3px' }}>Requested by :
                                                  <span style={{ color: '#000000' }}> {obj?.swap_request_by?.fullName} , Shift - {moment(obj?.swap_by_shift_details?.Shift_Date).format('MM/DD/YY')}</span>
                                                </p>
                                                <p style={{ marginBottom: '3px' }}>Requested to :
                                                  <span style={{ color: '#000000' }}> {obj?.swap_with?.fullName}, Shift - {moment(obj?.swap_to_shift_details?.Shift_Date).format('MM/DD/YY')}</span>
                                                </p>
                                                <div className="mt-3">
                                                  <ButtonTheme
                                                    disable={saving}
                                                    color="DarkGreen"
                                                    className="rounded-2"
                                                    onClick={() => acceptOTswaps(obj, "approve")}
                                                  >
                                                    Accept
                                                  </ButtonTheme>
                                                  <ButtonTheme
                                                    disable={saving}
                                                    color="red"
                                                    className="rounded-2 mx-2"
                                                    onClick={() => acceptOTswaps(obj, "deny")}
                                                  >
                                                    Reject
                                                  </ButtonTheme>
                                                </div>
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Box>
                                  </Grid>
                                );
                              }
                            })
                          ) : (
                            <div className='d-flex flex-column align-items-center justify-content-center w-100' style={{ height: 500 }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Requests Found
                              </span>
                            </div>
                          )}
                        </Grid>
                      </Box>
                    )}
                  </div>
                </>
              }

              {/* Vaction Swap Requests */}
              {activeTab == 'vswaps' &&
                <>
                  <div>
                    {!loading && (
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                        }}
                      >
                        <Grid container spacing={2} className='mt-2 mb-3'>
                          {vacRows.length > 0 ? (
                            vacRows.map((obj) => {
                              {
                                return (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        padding: '16px',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        border: '1px solid #EBECF0',
                                        boxShadow: `
                                        0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                        0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                        0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                      `,
                                      }}
                                    >
                                      <TableContainer>
                                        <Table aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                Shift
                                              </TableCell>
                                              <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                                {obj?.request_details?.request_shift_code == '2' ? 'Day' : 'Night'}
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            <TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                style={{
                                                  padding: '0px',
                                                  fontSize: '14px',
                                                  fontFamily: 'karla',
                                                  padding: '7px',
                                                  color: '#555555'
                                                }}
                                              >
                                                <p style={{ marginBottom: '3px' }}>Requested by :
                                                  <span style={{ color: '#000000' }}> {obj?.swap_request_by?.fullName} , Shift - {moment(obj?.request_details?.request_date).format('MM/DD/YY')}</span>
                                                </p>
                                                <p style={{ marginBottom: '3px' }}>Requested to :
                                                  <span style={{ color: '#000000' }}> {obj?.swap_with?.fullName} , Shift - {moment(obj?.Shift_Date).format('MM/DD/YY')}</span>
                                                </p>

                                                <div className="mt-3">
                                                  <ButtonTheme
                                                    disable={saving}
                                                    color="DarkGreen"
                                                    className="rounded-2"
                                                    onClick={() => acceptVacswaps(obj, "ACCEPT")}
                                                  >
                                                    Accept
                                                  </ButtonTheme>
                                                  <ButtonTheme
                                                    disable={saving}
                                                    color="red"
                                                    className="rounded-2 mx-2"
                                                    onClick={() => acceptVacswaps(obj, "REJECT")}
                                                  >
                                                    Reject
                                                  </ButtonTheme>
                                                </div>
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Box>
                                  </Grid>
                                );
                              }
                            })
                          ) : (
                            <div className='d-flex flex-column align-items-center justify-content-center w-100' style={{ height: 500 }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Request Found
                              </span>
                            </div>
                          )}
                        </Grid>
                      </Box>
                    )}
                  </div>
                </>
              }

              {/* Remove RTO List */}
              {activeTab == 'removeRtoList' &&
                <>
                  <div>
                    {!loading && (
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                        }}
                      >
                        <Grid container spacing={2} className='mt-2 mb-3'>
                          {removeRtoList.length > 0 ? (
                            removeRtoList.map((obj) => {
                              {
                                return (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        padding: '16px',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        border: '1px solid #EBECF0',
                                        boxShadow: `
                                        0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                        0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                        0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                      `,
                                      }}
                                    >
                                      <TableContainer>
                                        <Table aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                Shift
                                              </TableCell>
                                              <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                                {obj?.removal_request_shifts[0]?.Shift_Code === 2 ? 'Day' : 'Night'}
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            <TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                style={{
                                                  padding: '0px',
                                                  fontSize: '14px',
                                                  fontFamily: 'karla',
                                                  padding: '7px',
                                                  color: '#555555'
                                                }}
                                              >
                                                <p style={{ marginBottom: '3px' }}>Requested by :
                                                  <span style={{ color: '#000000' }}> {obj?.employee_detail.fullName}</span>
                                                </p>

                                                <p style={{ marginBottom: '3px' }}>Shift date :
                                                  <span style={{ color: '#000000' }}> {moment(obj?.Shift_Date).format('MM/DD/YY')}</span>
                                                </p>

                                                <div className="mt-3">
                                                  <ButtonTheme
                                                    disable={saving}
                                                    color="DarkGreen"
                                                    className="rounded-2"
                                                    onClick={() => removeRtoRequestDecesion(obj, "approve")}
                                                  >
                                                    Approve
                                                  </ButtonTheme>
                                                  <ButtonTheme
                                                    disable={saving}
                                                    color="red"
                                                    className="rounded-2 mx-2"
                                                    onClick={() => removeRtoRequestDecesion(obj, "deny")}
                                                  >
                                                    Reject
                                                  </ButtonTheme>
                                                </div>
                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Box>
                                  </Grid>
                                );
                              }
                            })
                          ) : (
                            <div className='w-100 d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Shifts Found
                              </span>
                            </div>
                          )}
                        </Grid>
                      </Box>
                    )}
                  </div>
                </>
              }

              {activeTab == 'passes' &&
                <div className="mt-4">
                  <ManageFreePasses freePasses={freePasses} getFreePasses={getFreePasses} />
                </div>
              }

              {/* Sell Holiday Request */}
              {activeTab == 'sholiday' &&
                <>
                  <div>
                    {!loading && (
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                        }}
                      >
                        <Grid container spacing={2} className='mt-2 mb-3'>
                          {sellHolidayRequest.length > 0 ? (
                            sellHolidayRequest.map((obj) => {
                              {
                                return (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        padding: '16px',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        border: '1px solid #EBECF0',
                                        boxShadow: `
                                        0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                        0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                        0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                      `,
                                      }}
                                    >
                                      <TableContainer>
                                        <Table aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                Date : {moment(obj?.Date).format('MM/DD/YY')}
                                              </TableCell>
                                              <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '12px', cursor: 'pointer' }}>
                                                <DescriptionOutlinedIcon
                                                  onClick={() => {
                                                    setNotesModal(true)
                                                    setNotesData(obj?.Note)
                                                  }} />
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            <TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                style={{
                                                  padding: '0px',
                                                  fontSize: '14px',
                                                  fontFamily: 'karla',
                                                  padding: '7px',
                                                  color: '#555555'
                                                }}
                                              >

                                                {/* <p style={{ marginBottom: '3px' }}>Date :
                                                  <span style={{ color: '#000000' }}> {moment(obj?.Date).format('MM/DD/YY')}</span>
                                                </p> */}

                                                <p style={{ marginBottom: '3px' }}>Requested by :
                                                  <span style={{ color: '#000000' }}> {obj?.employee.employee_assignment.EA_Rank + ' ' + obj?.employee.fullName}</span>
                                                </p>

                                                <p style={{ marginBottom: '3px' }}>Absent Code :
                                                  <span style={{ color: '#000000' }}> {obj?.sub_type.SO_Desc}</span>
                                                </p>

                                                <p style={{ marginBottom: '3px' }}>Requested :
                                                  <span style={{ color: '#000000' }}> {obj?.Total}</span>
                                                </p>

                                                {obj?.Status == 'Pending' ? (
                                                  <div className="mt-3">
                                                    <ButtonTheme
                                                      disable={saving}
                                                      color="DarkGreen"
                                                      className="rounded-2"
                                                      onClick={() => acceptSellHolidayRequest(obj)}
                                                    >
                                                      Approve
                                                    </ButtonTheme>
                                                    <ButtonTheme
                                                      disable={saving}
                                                      color="red"
                                                      className="rounded-2 mx-2"
                                                      onClick={() => rejectSellHolidayRequest(obj)}
                                                    >
                                                      Reject
                                                    </ButtonTheme>
                                                  </div>
                                                ) : (
                                                  <div className="mt-3">
                                                    <ButtonTheme
                                                      disable={saving}
                                                      style={{ backgroundColor: 'rgba(1, 120, 79, 0.1)', color: 'rgba(1, 120, 79, 1)', border: '1px solid rgba(1, 120, 79, 1)' }}
                                                      className="rounded-2"
                                                    >
                                                      Accepted
                                                    </ButtonTheme>
                                                  </div>
                                                )}


                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </TableContainer>

                                    </Box>
                                  </Grid>
                                );
                              }
                            })
                          ) : (
                            <div className='w-100 d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Request Found
                              </span>
                            </div>
                          )}
                        </Grid>
                      </Box>
                    )}
                  </div>
                </>
              }

              {activeTab == 'swap-cancel' &&
                <>
                  <div>
                    {!loading && (
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                        }}
                      >
                        <Grid container spacing={2} className='mt-2 mb-3'>
                          {swapCancelRequestData.length > 0 ? (
                            swapCancelRequestData.map((obj) => {
                              {
                                return (
                                  <Grid item xs={4}>
                                    <Box
                                      sx={{
                                        padding: '16px',
                                        backgroundColor: '#ffffff',
                                        borderRadius: '12px',
                                        border: '1px solid #EBECF0',
                                        boxShadow: `
                                        0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                        0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                        0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                      `,
                                      }}
                                    >
                                      <TableContainer>
                                        <Table aria-label="simple table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                Shift
                                              </TableCell>
                                              {obj?.Status == 'ACTIVE' &&
                                                <TableCell align="right" style={{ fontSize: obj?.removal_request_shifts[0]?.Shift_Code === 91 ? '12px' : '14px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                                  {obj?.removal_request_shifts[0]?.Shift_Code === 2 ? 'Day' : obj?.removal_request_shifts[0]?.Shift_Code === 91 ? `(${obj?.removal_request_shifts[0]?.Start_Time} - ${obj?.removal_request_shifts[0]?.End_Time})` : 'Night'}
                                                </TableCell>
                                              }
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                              <TableCell
                                                component="th"
                                                scope="row"
                                                style={{
                                                  padding: '0px',
                                                  fontSize: '14px',
                                                  fontFamily: 'karla',
                                                  padding: '7px',
                                                  color: '#555555'
                                                }}
                                              >

                                                <p style={{ marginBottom: '3px' }}>Date :
                                                  <span style={{ color: '#000000' }}> {moment(obj?.Shift_Date).format('MM/DD/YY')}</span>
                                                </p>

                                                <p style={{ marginBottom: '3px' }}>Shift Number :
                                                  <span style={{ color: '#000000' }}> {obj?.Shift_Number}</span>
                                                </p>

                                                <p style={{ marginBottom: '3px' }}>Requested by :
                                                  <span style={{ color: '#000000' }}> {obj?.employee_detail?.fullName}</span>
                                                </p>

                                                {obj?.Status == 'ACTIVE' &&
                                                  <p style={{ marginBottom: '3px' }}>Requested To :
                                                    <span style={{ color: '#000000' }}> {obj?.removal_request_shifts[0]?.filled_data[0]?.employee?.fullName}</span>
                                                  </p>
                                                }

                                                {obj?.Status == 'ACTIVE' ? (
                                                  <div className="mt-3">
                                                    <ButtonTheme
                                                      disable={saving}
                                                      color="DarkGreen"
                                                      className="rounded-2"
                                                      onClick={() => handleCancelSwapRequest(obj, 'approve')}
                                                    >
                                                      Approve
                                                    </ButtonTheme>
                                                    <ButtonTheme
                                                      disable={saving}
                                                      color="red"
                                                      className="rounded-2 mx-2"
                                                      onClick={() => handleCancelSwapRequest(obj, 'deny')}
                                                    >
                                                      Reject
                                                    </ButtonTheme>
                                                  </div>
                                                ) : (
                                                  <div style={{ marginTop: '40px' }}>
                                                    <ButtonTheme
                                                      disable={saving}
                                                      style={{
                                                        backgroundColor: obj?.Status == 'APPROVED' ? 'rgba(1, 120, 79, 0.1) ' : 'rgba(230, 39, 25, 0.1)',
                                                        color: obj?.Status == 'APPROVED' ? 'rgba(1, 120, 79, 1)' : '#ff0000',
                                                        border: obj?.Status == 'APPROVED' ? '1px solid rgba(1, 120, 79, 1)' : '1px solid rgba(230, 39, 25, 0.4)'
                                                      }}
                                                      className="rounded-2"
                                                    >
                                                      {obj?.Status}
                                                    </ButtonTheme>
                                                  </div>
                                                )}

                                              </TableCell>
                                            </TableRow>
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Box>
                                  </Grid>
                                );
                              }
                            })
                          ) : (
                            <div className='w-100 d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Request Found
                              </span>
                            </div>
                          )}
                        </Grid>
                      </Box>
                    )}
                  </div>
                </>
              }

              {activeTab == 'daily-swap-list' &&
                <>
                  <Box
                    sx={{
                      maxWidth: "93vw",
                      overflowX: "auto",
                      background: "#FFF",
                      marginTop: "1rem",
                    }}
                  >
                    {dailySwapListData.length > 0 &&
                      <div className="hide-header-checkbox-page">
                        <MyTable
                          rows={dailySwapListData}
                          columns={columns2}
                          useTopFilter={false}
                          hideFooter={true}
                          checkboxSelection={false}
                        />
                      </div>}
                    {dailySwapListData.length == 0 &&
                      <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500 }}>
                        <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                        <span className='mt-4' style={{ color: '#555555' }}>
                          No Shifts Found
                        </span>
                      </div>
                    }
                  </Box>
                </>
              }

            </div>
          </Grid>
        </Grid>
      </Paper >

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            height: "80vh",
            overflow: "auto",
          }}
        >
          <h4>Have Overtime At same Day </h4>
          {modalData &&
            modalData.length > 0 &&
            modalData.map((item) => {
              return (
                <Card
                  key={item.Emp_Code + item.Overtime_List}
                  className="m-2 p-2 bg-body-secondary"
                >
                  <p>Name : {item.fullName}</p>
                  <p>Shift : {item.Overtime_List}</p>
                  <p>Absent : {item.Absent}</p>
                  <p>Status : {item.StatusText}</p>
                </Card>
              );
            })}
          {modalData && modalData.length == 0 && (
            <p className=" text-center text-danger h3">Empty</p>
          )}
        </Box>
      </Modal>

      {/* Reason Modal */}
      <Modal show={reasonModal} size="md"
        onHide={() => { setReasonModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Reason for Shift Decline</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
            <div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
              {reason ? reason : 'Not declined'}
            </div>
          </Row>
        </Modal.Body>
      </Modal>

      {/* Deny Modal */}
      <Modal show={denyModal} size="md"
        onHide={() => { setDenyModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Deny Shift</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
            <div className="p-0" style={{ marginBottom: '12px' }}>
              <div>
                {rowSelectionModel.length > 1 ?
                  <p style={{ marginBottom: '10px' }}>Are you sure you want to deny the following shifts?</p>
                  :
                  <p style={{ marginBottom: '10px' }}>Are you sure you want to deny this shift?</p>
                }
                {rowSelectionModel.length > 1 ?
                  Object.entries(groupedEmployees).map(([name, shifts]) => (
                    <p key={name} className="mb-0">
                      <strong>{name}</strong> - {shifts.join(", ")}
                    </p>
                  ))
                  :
                  <p className="mb-0">
                    <strong>{selectSingleRowData?.Orig_Emp_fullName}</strong> - {moment(selectSingleRowData?.Shift_Date).format('MM/DD/YYYY')} {`(${selectSingleRowData?.Shift_Type})`}
                  </p>
                }
              </div>
            </div>
            <Col md={12} className="p-0">
              {allowedVars && Object.keys(allowedVars).includes('V3_REJECT_REASON_ENABLED') &&
                <div>
                  <label className="mt-1">Reason for denial<span style={{ color: 'rgb(191, 29, 45)' }}>*</span></label>
                  <TextField
                    className='mt-1 w-100'
                    multiline
                    color='secondary'
                    variant="outlined"
                    value={rejectReason}
                    placeholder="Enter Reason"
                    sx={{
                      "& .MuiInputBase-input": {
                        minHeight: '150px',
                        maxHeight: '150px',
                        overflow: 'scroll !important',
                        scrollbarWidth: 'none'
                      }
                    }}
                    onChange={(e) => setRejectReason(e.target.value)}
                  />
                </div>
              }
            </Col>
          </Row>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-3' onClick={() => { setDenyModal(false) }}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-3'
                onClick={() => Deny()}
              >
                Reject
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={notesModal} onHide={() => setNotesModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Notes</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ marginBottom: '10px' }}>{notesData ? notesData : 'No notes'}</Modal.Body>
      </Modal>

      <Modal show={approveModal} size="md"
        onHide={() => {
          setApproveModal(false)
          setApproveReason('')
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Approve Shift</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
            <div className="p-0" style={{ marginBottom: '12px' }}>
              <div>
                {rowSelectionModel.length > 1 ?
                  <p style={{ color: '#555555', marginBottom: '10px' }}>Are you sure you want to approve the following shifts?</p>
                  :
                  <p style={{ color: '#555555', marginBottom: '10px' }}>Are you sure you want to approve this shift?</p>
                }
                {rowSelectionModel.length > 1 ?
                  Object.entries(groupedEmployees).map(([name, shifts]) => (
                    <p key={name} className="mb-0">
                      <strong>{name}</strong> - {shifts.join(", ")}
                    </p>
                  ))
                  :
                  <p className="mb-0">
                    <strong>{selectSingleRowData?.Orig_Emp_fullName}</strong> - {moment(selectSingleRowData?.Shift_Date).format('MM/DD/YYYY')} {`(${selectSingleRowData?.Shift_Type})`}
                  </p>
                }
              </div>
            </div>
            <Col md={12} className="p-0">
              {allowedVars && Object.keys(allowedVars).includes('V3_APPROVE_REASON_ENABLED') &&
                <div>
                  <label className="mt-1">Reason for approval</label>
                  <TextField
                    className='mt-1 w-100'
                    multiline
                    color='secondary'
                    rows={6}
                    variant="outlined"
                    value={approveReason}
                    placeholder="Enter Reason"
                    sx={{
                      // "& .MuiInputBase-input": {
                      //   minHeight: '150px',
                      //   maxHeight: '150px',
                      //   overflow: 'scroll !important',
                      // }
                      "& textarea": {
                        overflowY: "auto",
                        overflowX: "hidden",
                        resize: "none",
                      },
                    }}
                    onChange={(e) => setApproveReason(e.target.value)}
                  />
                </div>
              }
            </Col>
          </Row>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-3' onClick={() => { setApproveModal(false) }}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-3'
                onClick={() => Approve()}
              >
                Approve
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={deleteModal} size="md"
        onHide={() => {
          handleCloseDeleteModal()
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Swap Record</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ color: '#555555', width: '80%' }}>
            Are you sure you want to delete this swap record ?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-3' onClick={handleCloseDeleteModal}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-3'
                onClick={handleDelete}
              >
                Delete
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal show={nonSwapDeleteModal} size="md"
        onHide={() => {
          handleCloseDeleteModal()
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Denied RTO Requests</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ color: '#555555', width: '80%' }}>
             Are you sure you want to delete the denied rto requests ?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-3' onClick={handleCloseDeleteModal}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-3'
                onClick={handleDeniedRTORequst}
              >
                Delete
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      {/* Comment Modal */}
      <Modal show={commentModal} size="md"
        onHide={() => { setCommentModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Comment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
            <div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
              {commentData ? commentData : 'No comment'}
            </div>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={() => {
        setShow(false)
        setSwapReason('')
      }}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Swap</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555', width: '80%' }}>
            Are you sure to cancel this swap ?
          </div>
          <Row className="mt-3">
            <Col md={12}>
              <label className="mb-1">Reason</label>
              <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                placeholder="Reason"
                value={swapReason}
                onChange={(e) => setSwapReason(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-4'
                onClick={() => {
                  setShow(false)
                  setSwapReason('')
                }}
              >
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handleDailySwapCancel(selectedSwapData)}>
                Submit
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default ApproveShifts;
